import { createWithEqualityFn } from 'zustand/traditional';
import { NestedHome } from '@habity/types';

// TODO: Fetch home using SWR and useParams instead

export interface AppProps {
  home: NestedHome | null;
  isMobile: boolean;
}

export interface AppState extends AppProps {
  setHome: (home: NestedHome | null) => void;
  setIsMobile: (isMobile: boolean) => void;
}

const DEFAULT_PROPS: AppProps = {
  home: null,
  isMobile: true,
};

export const useAppStore = createWithEqualityFn<AppState>()((set) => ({
  ...DEFAULT_PROPS,

  setHome: (home: NestedHome | null) => set({ home }),
  setIsMobile: (isMobile) => set({ isMobile }),
}));
